import styled from 'styled-components'

const OverlayHost = styled.div`
  position: relative;
  z-index: 2;
`

function TripChatMobileOverlayHost() {
  return <OverlayHost data-testid="trip-chat-mobile-overlay-host" />
}

export default TripChatMobileOverlayHost
